import React, {FC} from 'react';
import {Button} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Close';
import {useAccountDeletion} from '../../../models/AccountDeletion';

interface ButtonProps {
    field: string;
    fullWidth?: boolean | undefined;
    handleClick: (event: React.MouseEvent) => void;
    iconName?: string;
    style?: {
        lineHeight?: string;
    };
    disabled?: boolean;
}

export const FuncButtonWIcon: FC<ButtonProps> = ({field, fullWidth, handleClick, iconName, disabled}) => {
    const {isReadOnly} = useAccountDeletion();
    let icon = null;

    if (iconName === 'sendIcon') {
        icon = <SendIcon/>;
    }

    if (iconName === 'deleteIcon') {
        icon = <DeleteIcon/>;
    }

    if (iconName === 'cancelIcon') {
        icon = <CancelIcon/>;
    }

    const iconStyle =
        field && !fullWidth
            ? {
                width: '130px',
                minWidth: '130px',
            }
            : field && fullWidth
                ? {}
                : {
                    '& .MuiButton-endIcon': {
                        margin: 0,
                    },
                    width: '40px',
                    minWidth: '40px',
                };

    return (
        <Button
            size="small"
            fullWidth={fullWidth}
            variant="outlined"
            disabled={disabled || (isReadOnly && iconName !== 'cancelIcon')}
            color={iconName === 'deleteIcon' ? 'error' : 'primary'}
            sx={{
                ...iconStyle,
                margin: '0px',

            }}
            onClick={handleClick}
            endIcon={icon}
        >
            {field}
        </Button>
    );
};
